import { Container, Row, Col } from "react-bootstrap";
import { Mailchimp } from "./Mailchimp";
import navIcon1 from "../assets/img/nav-icon1.svg";
import navIcon2 from "../assets/img/socialIcon4.png";
import navIcon3 from "../assets/img/nav-icon3.svg";
import logo from "../assets/img/image.png";

export const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row className="align-item-center">
          <Mailchimp />
          <Col sm={6}>
            <img src={logo} alt="logo" className="logo" />
          </Col>
          <Col sm={6} className="text-center text-sm-end">
            <div className="social-icon">
              <a href="https://www.linkedin.com/in/a-sai-ram-reddy-7596a9254/">
                {" "}
                <img src={navIcon1} alt="" />
              </a>
              <a href="https://www.youtube.com/@sairamrdya">
                {" "}
                <img src={navIcon2} alt="" />
              </a>
              <a href="https://www.instagram.com/mr_sairam_arava">
                {" "}
                <img src={navIcon3} alt="" />
              </a>
            </div>
            <p>Copyright 2025. All Rights Reserved.</p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};
